require('./recentActivity.tpl.html');
require('./recentActivityController.js');

const RecentActivityComponent = {
    templateUrl: '/landing/widget/recentActivity/recentActivity.tpl.html',
    controller: 'recentActivityController',
    bindings: {
        widgetConfig: '<',
        filterType: '<'
    }
};

angular.module('umLanding')
    .component('uiRecentActivity', RecentActivityComponent);
